interface IAppState {
    innerAccessToken: string;
    innerHmac: string;
}

interface Content2AppMap {
    notifyAppState: IAppState;
}

const post = (message: any) => {
    if (window && window.top) {
        window.top.postMessage(message, '*');
    } else {
        throw new Error('[TT] Failed post(No window.top!)');
    }
};

type MsgTypes = keyof Content2AppMap;
const postAppMsg = (type: MsgTypes, msg?: any) => {
    post({ type, msg, from: 'launcher', srcFrame: 'navi', tgtFrame: 'navi' });
};

const _getAppState = () => {
    const msg = {
        addOnHost: '',
        attention: false,
        bookCompleted: 0,
        bookid: 0,
        classOpen: false,
        classid: 0,
        classidReal: 0,
        curriculumId: 0,
        displayMode: '1',
        domain: '',
        domainKey: '',
        entryCnt: 0,
        frIdx: 0,
        fullscreen: false,
        isApp: false,
        isIos: false,
        isMobile: false,
        isRemoteZoom3: false,
        lock: false,
        login: 0,
        mirroring: false,
        myInfo: {
            id: '',
            learn_idx: 0,
            classid: 0,
            claId: 'b7a0a9f78f334ec1b1840635ed37e044',
            claCD: '',
            lectureCode: '',
            claNm: '',
            frIdx: 0,
            name: '',
            firstName: '',
            lastName: '',
            nickName: '',
            thumbnail: '',
            defaultThumbnail: '',
            profileThumbnail: '',
            birthday: '',
            gender: 'F',
            displayMode: '1',
            uuid: '',
            code: '',
            saveUID: '',
            savePWD: '',
            autoLogin: false,
            saveID: false,
            age: 0,
        },
        notSupportRemote: true,
        onRemote: false,
        prodIdx: 0,
        renderCount: 0,
        screenEnabled: false,
        privacyDomain: '',
        service: 'aidt',
        socketHostName: '',
        soundEnabled: false,
        studentCnt: 0,
        ui: 'aidt',
        union: false,
        userDiv: 'S',
        classId: '',
        accessId: '',
        accessToken: '',
        partnerId: 'd79366e1-d506-51c4-a758-601f2945a7a4',
        innerAccessToken: sessionStorage.getItem('accessToken'), // jwt 토큰
        innerHmac: sessionStorage.getItem('accessToken'), // hmac
    };
    return msg;
};

const launcher = {
    // (공통) notifyAppState 요청
    getAppState: () => {
        const msg = _getAppState();
        console.log('[TT] notifyAppState 발신 >>>>> ', msg);
        postAppMsg('notifyAppState', msg);
    },
};
export default launcher;

export const handleMessageEvent = (message: MessageEvent) => {
    const { data } = message;
    if (!data) return;
    const { type, from, msg } = data;
    switch (type) {
        case 'getAppState':
            {
                console.log('[TT] getAppState 수신(from:' + from + ') >>>>> ', msg);
                postAppMsg('notifyAppState', _getAppState());
            }
            break;
        default:
            break;
    }
};
